import { GeneralTable } from "@/shared/components/ui";
import { useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { EstadoSolicitudDeudaENUM, TABLE_CONSTANTS } from "@/shared";
import { Edit } from "@mui/icons-material";
import { fetchGetSolicitudDeuda, fetchPutSolicitudDeuda } from "@/shared/actions/erp/solicitud_deuda/solicitud_deuda.actions";
import { ISolicitudDeuda } from "@/shared/interfaces/erp/solicitud_deuda/solicitud_deuda.interface";
import { useTableColumnsSolicitudDeuda } from "@/shared/hooks/useTableColumnsSolicitudDeuda";
import { useUiStore } from "@/store/ui";

interface TableSolicitudDeudaProps {
  estado_solicitud?: EstadoSolicitudDeudaENUM
  enableActions?: boolean
}
export default function TableSolicitudDeuda({
  estado_solicitud = EstadoSolicitudDeudaENUM.EN_ESPERA,
  enableActions = true
}: TableSolicitudDeudaProps) {

  ///* use state

  ///* form

  ///* Hooks
  const {
    columnsBase
  } = useTableColumnsSolicitudDeuda({
    estado_solicitud
  });

  const {
    pagination,
    setPagination,
    vendedor,
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  const {
    filterObject,
    columnFilters,
    setColumnFilters
  } =
    useTableServerSideFiltering();

  const { isLoading, data: prospectoRes, isRefetching } =
    fetchGetSolicitudDeuda({
      page: pageIndex + 1,
      estado_solicitud: estado_solicitud,
      page_size: pageSize,
      user_create: vendedor,
      ...filterObject,
      filterByState: false
    });

  const {
    mutateAsync: mutateAsyncPut
  } = fetchPutSolicitudDeuda({})

  const setConfirmDialog = useUiStore(s => s.setConfirmDialog)
  const setConfirmDialogIsOpen = useUiStore(s => s.setConfirmDialogIsOpen);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>

        </Grid>

        <Grid item xs={12}>
          <GeneralTable<ISolicitudDeuda>
            columns={columnsBase}
            data={prospectoRes?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            ///* search
            enableGlobalFilter={false}
            enableSorting={false}

            ///* pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={prospectoRes?.data?.count}
            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}

            // crud
            canEdit={false}
            enableEditing={enableActions}
            showCustomActionBtnSpace={enableActions}
            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_SMALL}

            customActionBtnSpace={(value) => {
              return (
                <Grid container>
                  <Grid item >
                    <Tooltip title={'Editar'} placement="top">
                      <IconButton
                        onClick={() => {
                          setConfirmDialogIsOpen(true);

                          setConfirmDialog({
                            isOpen: true,
                            title: '¡Valores pendientes!',
                            subtitle: `El cliente tiene una deuda pendiente por cobrar de $${value.deuda}. ¿Quieres liberar la solicitud para continuar con la venta? Por favor, considera que este cambio es irreversible.`,
                            confirmTextBtn: 'Confirmar',
                            onClose() {
                              setConfirmDialogIsOpen(false);
                            },

                            async onReject() {

                              await mutateAsyncPut({
                                id_solicitud_pasar_deuda: value.id_solicitud_pasar_deuda,
                                identificacion: value.identificacion,
                                estado_solicitud: EstadoSolicitudDeudaENUM.RECHAZADO
                              })

                              setConfirmDialogIsOpen(false);
                            },
                            async onConfirm() {
                              await mutateAsyncPut({
                                id_solicitud_pasar_deuda: value.id_solicitud_pasar_deuda,
                                identificacion: value.identificacion,
                                estado_solicitud: EstadoSolicitudDeudaENUM.APROBADO
                              })
                              setConfirmDialogIsOpen(false);
                            },
                            cancelTextBtn: 'Cerrar',
                          });
                        }
                        }
                      >
                        <Edit />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              )
            }}

          />
        </Grid>
      </Grid>



    </>
  );
}